// =====================================================================
// commande-prete/suppression.js — Commandes prêtes (16-10-2026) — « SUPPRIMER LE BROUILLON »
// =====================================================================
// Décision Silviu 16/10 : « pouvoir supprimer les brouillons (seulement) ». Le serveur décide
// (`supprimable` dans la liste et dans le CommandeDTO) : un brouillon jamais envoyé — aucun mail parti,
// aucune unité chargée, aucune mesure EffiTrace —, ou une commande de TEST (sauf pendant son envoi).
// Le bouton n'apparaît que dans ces cas ; la confirmation se fait SUR LA PAGE (jamais window.confirm),
// le focus va sur « Annuler », jamais sur « Oui, supprimer ».
// Fonctions PURES (aucun DOM) : testées par frontend/test/commande-prete.test.mjs.
// =====================================================================

/** Le bouton s'affiche-t-il ? Seulement si le serveur le permet, pour qui a « Encoder et envoyer »
 *  (`encoder`, droits propres du module — SPEC v3 D, 17/10 ; sinon 403 « Droit manquant ») ou l'admin du
 *  module ; une commande de test : administrateurs seulement (décision Silviu 17/10, 403 TEST_RESERVE_ADMIN). */
export const peutSupprimer = (o, admin = false, encoder = false) => !!o && o.supprimable === true
  && (admin === true || encoder === true) && (!o.isTest || admin === true);

// Une commande de test déjà envoyée n'est plus un « brouillon » : le bouton le dit.
// (Lignes de la vue d'ensemble : la page pose `status` depuis leur `statut` avant d'appeler ces fonctions.)
const estBrouillon = (o) => !o.isTest || o.status === 'BROUILLON';

/** Libellé du bouton. */
export const libelleSuppression = (o) => (estBrouillon(o) ? 'Supprimer le brouillon' : 'Supprimer la commande de test');

/** Question posée sur la page avant de supprimer. */
export function texteConfirmationSuppression(o) {
  const quoi = estBrouillon(o) ? (o.isTest ? 'le brouillon de test' : 'le brouillon') : 'la commande de test';
  const client = o.client && o.client.name ? ` (${o.client.name})` : '';
  return `Supprimer ${quoi} ${o.orderRef}${client} ? Ses palettes, colis et photos sont effacés : impossible de revenir en arrière.`;
}

/** Message affiché une fois la commande supprimée. */
export const texteSupprimee = (o) => (estBrouillon(o)
  ? `Brouillon ${o.orderRef}${o.isTest ? ' (test)' : ''} supprimé.`
  : `Commande de test ${o.orderRef} supprimée.`);

/** Refus du serveur (409, motif dans le message) ou commande déjà disparue (404) : texte pour l'écran. */
export function texteRefusSuppression(err, messageReseau) {
  const r = err && err.response;
  // Pas de réponse : peut-être supprimée quand même — l'écran relit la liste (ou la commande).
  if (!r) return `Pas de réponse du serveur (${messageReseau || 'réseau'}) : la commande a peut-être été supprimée — vérifiez dans la liste.`;
  if (r.status === 404) return 'Cette commande n\'existe plus (déjà supprimée ?).';
  return (r.data && r.data.message) || messageReseau || 'Suppression refusée.';
}
